/**
 * Get the index name for the given item type, sort by, and order.
 * These need to match the index names in the Algolia dashboard.
 * @param type The main type of the index
 * @param sortBy The replica to use (e.g. price, alpha, etc.)
 * @param order Ascending or descending order
 */
export const getIndexName = (
  itemType: 'products' | 'product_groups',
  sortBy?: 'price' | 'alpha' | 'updated',
  order?: 'asc' | 'desc'
) => {
  let indexName = ALGOLIA_INFO.USE_PRODUCTION ? itemType : `${itemType}_stage`;

  if (sortBy) {
    indexName += `_${sortBy}`;
  }

  if (order) {
    indexName += `_${order}`;
  }

  return indexName;
};

/** Build out the options for the sortBy widget */
export const buildSortByOptions = () => {
  return [
    { label: 'Default',
      value: getIndexName('products') },
    // { label: 'Recommended (TODO)',
    //   value: getIndexName('products') },
    { label: 'Price (low to high)',
      value: getIndexName('products', 'price', 'asc') },
    { label: 'Price (high to low)',
      value: getIndexName('products', 'price', 'desc') },
    { label: 'Newest',
      value: getIndexName('products', 'updated', 'desc') },
    // { label: 'Best selling (TODO)',
    //   value: getIndexName('products') },
    { label: 'Alphabetical',
      value: getIndexName('products', 'alpha', 'asc') },
  ];
};
